import React, { useEffect, useState } from 'react'
import { View, Text, StyleSheet, FlatList, Pressable, TextInput, Dimensions, Linking } from 'react-native'
import { useSelector } from 'react-redux';
import { collection, deleteDoc, doc, onSnapshot } from 'firebase/firestore';

import DashboardHeader from '../components/DashboardHeader';
import { colors } from '../components/Shared';
import { ResourcesScreenProps } from '../types';
import { RootState } from "../services/store/app";
import ModalResource from '../components/ModalResource';
import { db } from '../services/connect';
import { CandidateProps } from '../types/candidate';
import CandidateCard from '../components/CandidateCard';

const { width } = Dimensions.get('window');
const columnsQty: number = (() => {
	const columns = Math.floor(width / 270);
	if (columns < 1) {
		return 1;
	}

	if (columns > 4) {
		return 4;
	}

	return columns;
})();

function Resources({ navigation }: ResourcesScreenProps) {
	const common = useSelector((state: RootState) => state.commonReducer);
	const isAdmin = common.user.roll > 0;

	const [showContactModal, setShowContactModal] = useState(false);
	const [candidates, setCandidates] = useState<CandidateProps[]>([]);
	const [search, setSearch] = useState('');

	useEffect(() => {
		const ref = collection(db, 'candidates')
		onSnapshot(ref, (snap) => {
			if (snap.docs.length === 0) {
				return setCandidates([]);
			}

			const { docs } = snap;
			setCandidates(
				docs.map(doc => ({
					...doc.data(),
					id: doc.id
				} as CandidateProps))
			)
		});

	}, []);

	function filteredCandidates() {
		if (!search || search == '') {
			return candidates;
		}

		return candidates
			.filter(({ name, location, profession, recruitmentCompany }) =>
				name.toLowerCase().includes(search.toLowerCase()) ||
				location.toLowerCase().includes(search.toLowerCase()) ||
				profession.toLowerCase().includes(search.toLowerCase()) ||
				recruitmentCompany?.toLowerCase().includes(search.toLowerCase())
			);
	}

	function deleteCandidate(id: string, name: string) {
		const _continue = confirm(`You are about to delete the record of "${name}"`);
		if (!_continue) {
			return;
		}

		deleteDoc(doc(db, 'candidates/' + id));
	}

	return (
		<View style={styles.container}>
			<DashboardHeader
				onPressSettings={() => navigation.navigate("Settings")}
				isAdmin={isAdmin}
			/>

			<View style={styles.content}>
				<View style={styles.headerContainer}>
					<TextInput
						style={{
							backgroundColor: colors.bg.medium,
							borderRadius: 10,
							paddingLeft: 10,
							width: 300
						}}
						onChangeText={setSearch}
						value={search}
						placeholder="Search"
					/>

					<Pressable
						style={styles.createBtn}
						onPress={() => setShowContactModal(true)}
					>
						<Text style={{ color: '#fff', fontWeight: 'bold' }}>Add Resource</Text>
					</Pressable>
				</View>


				<FlatList
					data={filteredCandidates()}
					renderItem={({ item }) => (
						<CandidateCard
							id={item.id!}
							name={item.name}
							location={item.location}
							recruitmentCompany={item.recruitmentCompany || '-/-'}
							profession={item.profession}
							onDelete={() => deleteCandidate(item.id!, item.name)}
							onPressDoc={() => Linking.openURL(item.resumeUrl)}
						/>
					)}
					style={{ marginTop: 40 }}
					numColumns={columnsQty}
				/>
			</View>

			<ModalResource
				visible={showContactModal}
				close={(() => setShowContactModal(false))}
			/>
		</View>
	)
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		marginHorizontal: "auto",
		backgroundColor: colors.bg.light,
		width: "100%",
		maxWidth: 1200,
	},
	content: {
		padding: 20
	},
	headerContainer: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		shadowColor: '#000',
		shadowOffset: {
			height: 10,
			width: 0
		},
		shadowOpacity: 0.2,
		shadowRadius: 20,
		padding: 10,
		borderRadius: 4
	},
	createBtn: {
		backgroundColor: colors.bg.primary,
		borderRadius: 8,
		justifyContent: 'center',
		alignItems: 'center',
		padding: 10
	}
});

export default Resources